import React from "react";
import CustomPasswordInput from "components/CustomPasswordsInput";
import { IErrorMessageLogin, LoginForm } from "models/login";
import { useLoginContext } from "context/login-context";
import validator from "validator";
import * as S from 'pages/login/style';

function InputLogin() {
  const {
    loginData,
    isLoading,
    setLoginData,
    errorMessage,
    setErrorMessage,
  } = useLoginContext();

  const changeLogin = (field, value) => {
    if (!validator.isEmail(value) && value !== '') {
      setErrorMessage(IErrorMessageLogin.EMAIL_FORMATO_INVALIDO);
    } else {
      setErrorMessage('');
    }
    setLoginData({
      ...loginData,
      [field]: value,
    } as LoginForm);
  };

  return (
    <>
      <S.InputGroupStyled
        show
        errorMessagePosition={errorMessage === IErrorMessageLogin.EMAIL_FORMATO_INVALIDO ? 'bottom' : 'top'}
      >
        <S.CustomEmailInput
          id='email-login-input'
          label='Email'
          fullWidth
          InputProps={{
            disableUnderline: true,
          }}
          value={loginData?.email}
          disabled={isLoading}
          onChange={(event) => changeLogin('email', event.target.value)}
          error={!!(errorMessage && errorMessage !== IErrorMessageLogin.ERRO_SERVICO)}
        />
        <S.ErrorMessageStyled dangerouslySetInnerHTML={{ __html: errorMessage }}/>
      </S.InputGroupStyled>
      <S.InputGroupStyled
        className="input-group-password"
        show
      >
        <CustomPasswordInput
          changeLogin={changeLogin}
          disabled={isLoading}
          passwordData={loginData?.password}
        />
      </S.InputGroupStyled>

      <S.LinkStyled
        color='#4A90E2'
        textDecoration='none'
        margin='0 0 0 24px'
        alignSelf='flex-start'
        href="/ies/configuracoes/solicitar-recuperacao-senha">
        Esqueceu?
      </S.LinkStyled>
    </>
  )
}

export default InputLogin;